<div class="each-page">
    <!-- Page Header -->
    <div class="page-header">
        <div class="page-header__content">
            <div class="page-left gap-2.5">
                <div class="page-icon">
                    <img
                        src="../assets/img/dashboard.svg"
                        class="h-8"
                        alt="Difficulty levels"
                    />
                </div>

                <div class="page-headings">
                    <h1>{{ pageTitle }}</h1>

                    <p *ngIf="pageSubtitle">
                        {{ pageSubtitle }}
                    </p>
                </div>
            </div>
        </div>

        <div class="page-header-right">
            <div class="course-search">
                <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <path
                        d="m21 21-4.35-4.35m1.35-5.65a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                    ></path>
                </svg>

                <input
                    type="search"
                   
                    (ngModelChange)="onSearchChange()"
                    placeholder="Search difficulty levels..."
                    aria-label="Search difficulty levels"
                />

                <span class="search-shortcut">
                    Ctrl + K
                </span>
            </div>

            <button
                type="button"
                class="add-course-button"
                (click)="addDifficultyLevel()"
            >
                <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <path d="M12 5v14M5 12h14"></path>
                </svg>

                <span>Add Difficulty Level</span>
            </button>
        </div>
    </div>

    <!-- Page Content -->
    <div class="page-content">
        <section class="course-table-card">
            <div
                class="table-responsive"
                *ngIf="
                    filteredDifficultyLevels.length > 0;
                    else noDifficultyLevels
                "
            >
                <table class="course-table difficulty-level-table">
                    <thead>
                        <tr>
                            <th>Name</th>

                            <th class="action-column">
                                Action
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            *ngFor="
                                let difficultyLevel
                                    of paginatedDifficultyLevels;
                                trackBy:
                                    trackByDifficultyLevelId
                            "
                        >
                            <td data-label="Name">
                                <div class="course-title-group">
                                    <h3>
                                        {{
                                            difficultyLevel.name
                                        }}
                                    </h3>
                                </div>
                            </td>

                            <td
                                class="action-column"
                                data-label="Action"
                            >
                                <div
                                    ngbDropdown
                                    class="d-inline-block action-dropdown"
                                    container="body"
                                >
                                    <button
                                        type="button"
                                        class="btn btn-outline-primary"
                                        [id]="
                                            'difficultyLevelActions' +
                                            difficultyLevel.id
                                        "
                                        ngbDropdownToggle
                                        aria-label="Difficulty level actions"
                                    >
                                        <i
                                            class="fa fa-ellipsis-v"
                                            aria-hidden="true"
                                        ></i>
                                    </button>

                                    <div
                                        ngbDropdownMenu
                                        [attr.aria-labelledby]="
                                            'difficultyLevelActions' +
                                            difficultyLevel.id
                                        "
                                        class="dp-items"
                                    >
                                        <button
                                            type="button"
                                            ngbDropdownItem
                                            (click)="
                                                editDifficultyLevel(
                                                    difficultyLevel
                                                )
                                            "
                                        >
                                            <img
                                                src="../assets/img/edit.svg"
                                                class="h-4 mr-2"
                                                alt=""
                                            />

                                            Edit
                                        </button>

                                        <button
                                            type="button"
                                            ngbDropdownItem
                                            class="text-danger"
                                            (click)="
                                                deleteDifficultyLevel(
                                                    difficultyLevel
                                                )
                                            "
                                        >
                                            <img
                                                src="../assets/img/delete.svg"
                                                class="h-4 mr-2"
                                                alt=""
                                            />

                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <ng-template #noDifficultyLevels>
                <div class="empty-state">
                    <div>
                        <img
                            src="../../../../assets/img/no-data.svg"
                            class="h-64"
                            alt="No difficulty levels"
                        />
                    </div>

                    <h3>No data found</h3>

                    <p>
                        Try changing the difficulty-level
                        search text.
                    </p>

                    <button
                        type="button"
                        class="clear-filter-button"
                        (click)="clearFilters()"
                    >
                        Clear filters
                    </button>
                </div>
            </ng-template>

            <!-- Pagination -->
            <div
                class="table-footer"
                *ngIf="
                    filteredDifficultyLevels.length > 0
                "
            >
                <div class="pagination-summary">
                    Showing
                    <strong>{{ startItem }}</strong>
                    –
                    <strong>{{ endItem }}</strong>
                    of
                    <strong>
                        {{
                            filteredDifficultyLevels.length
                        }}
                    </strong>
                    difficulty levels
                </div>

                <div class="pagination-container">
                    <ngb-pagination
                        [(page)]="page"
                        [pageSize]="pageSize"
                        [collectionSize]="
                            filteredDifficultyLevels.length
                        "
                        [maxSize]="5"
                        [rotate]="true"
                        [ellipses]="true"
                        [boundaryLinks]="false"
                        [directionLinks]="true"
                        aria-label="Difficulty-level pagination"
                    >
                    </ngb-pagination>
                </div>

                <div class="page-size-control">
                    <label for="difficultyLevelPageSize">
                        Rows per page
                    </label>

                    <select
                        id="difficultyLevelPageSize"
                        [value]="pageSize"
                        (change)="
                            onPageSizeChange($event)
                        "
                    >
                        <option value="5">5</option>
                        <option value="8">8</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                    </select>
                </div>
            </div>
        </section>
    </div>
</div>